<template>

    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/user' }">基础设置</el-breadcrumb-item>
                    <el-breadcrumb-item>待审核用户</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="user" class="demo-form-inline" size="mini">
                    <el-row>
                        <el-form-item label="用户名" :label-width="formLabelWidth" clearable>
                            <el-input v-model="user.condition.userName" placeholder="用户名"></el-input>
                        </el-form-item>
                        <el-form-item label="状态" :label-width="formLabelWidth">
                            <el-select v-model="user.condition.userStatus" filterable placeholder="请选择" clearable>
                                <el-option
                                v-for="item in dataStatuses"
                                :key="item.dictCode"
                                :label="item.dictDesc"
                                :value="item.dictCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="姓名" :label-width="formLabelWidth">
                            <el-input v-model="user.condition.userRealName" placeholder="姓名" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="创建日期" :label-width="formLabelWidth">
                            <el-date-picker
                                v-model="user.condition.createTime"
                                type="date"
                                placeholder="选择日期" format="yyyy-MM-dd" valueFormat="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                    </el-row>
                    <el-row :span="24" type="flex" style="justify-content: right;">
                        <el-form-item>
                            <el-button type="info" @click="queryUser">查询</el-button>
                            <!-- <el-button type="primary" @click="createUser">新增</el-button> -->
                        </el-form-item>
                    </el-row>
                </el-form>
            </el-col>
        </el-row>
        <!-- <el-row type="flex" style="justify-content: right;" class="button-row">
            <el-button type="primary" @click="createUser">新增</el-button>
        </el-row> -->
        <el-row>
            <el-col :span="24">
                <el-table
                    :data="users"
                    size="mini"
                    border
                    :height="tableHeight"
                    v-loading="loading"
                    empty-text="暂无数据"
                    style="width: 100%">
                    <el-table-column fixed type="index" label="序号" width="50"></el-table-column>
                    <el-table-column fixed prop="userName" label="用户名" width="200"></el-table-column>
                    <el-table-column prop="userRealName" label="姓名" width="200"></el-table-column>
                    <el-table-column prop="roleName" label="角色" width="150"></el-table-column>
                    <el-table-column prop="phoneNo" label="手机号" width="200"></el-table-column>
                    <el-table-column prop="email" label="邮箱" width="200"></el-table-column>
                    <el-table-column prop="userStatusDesc" label="状态" width="200"></el-table-column>
                    <el-table-column prop="unit" label="单位" width="200"></el-table-column>
                    <el-table-column prop="deptName" label="组织部门" width="200"></el-table-column>
                    <el-table-column prop="post" label="职称" width="200"></el-table-column>
                    <el-table-column prop="parentName" label="导师/上级" width="200"></el-table-column>
                    <el-table-column prop="businessLicense" label="营业执照" width="200"></el-table-column>
                    <el-table-column prop="survivalStatus" label="公司存续状态" width="200"></el-table-column>
                    <el-table-column prop="userLevel" label="客户等级" width="200"></el-table-column>
                    <el-table-column prop="isSequencingDesc" label="是否测序" width="200"></el-table-column>
                    <el-table-column prop="sequenceCompany" label="送测公司" width="200"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="80">
                        <template slot-scope="scope">
                            <el-button @click="update(scope.row)" type="text" size="small">审核</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="block">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10,20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>

        <!-- <el-dialog title="用户审核" :visible.sync="dialogFormVisible"  append-to-body>
            <UserUpdate :key="timer" :userProp="userProp"></UserUpdate>
        </el-dialog> -->
        <el-drawer
            :title="title"
            :visible.sync="drawer"
            :direction="direction"
            :before-close="handleClose"
            size="50%">
            <UserUpdate :key="timer" :userProp="userProp"></UserUpdate>
        </el-drawer> 
        
    </div>
    
</template>

<script>
    import UserUpdate from './UserUpdate.vue';
    import GlobeConstant from '../../assets/js/GlobeConstant.js';

    export default {
        name:'User',
        components: {
            UserUpdate
        },
        data() {
            var validatePassword = (rule, value, callback) => {
                if(value) {
                    let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[a-zA-Z0-9]{8,20}$/
                    if(!reg.test(value)) {
                        callback(new Error("密码必须包含字母和数字，长度为8-20位"));
                    }
                }
                callback();
            };
            return {
                user:{
                    condition:{},
                    pageNum: 1,
                    pageSize:0
                },
                drawer: false,
                direction: 'rtl',
                users: [],
                currentPage: 1,
                pageSize:10,
                total:10,
                timer:'',
                userProp:{},
                title:"用户审核",
                dataStatuses:[],
                dialogFormVisible: false,
                formLabelWidth:"120px",
                updateUser: {
                    userId: "",
                },
                currentUserId: "",
                rules: {
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { validator: validatePassword, trigger: 'blur' }
                    ]
                },
                loading: true,
                tableHeight: "",//表格高度
            }
        },
        methods: {
            update(row) {
                this.drawer = true;
                this.userProp = row;
                this.timer = new Date().getTime();
            },
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
                this.queryUser();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryUser();
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.queryUser();
                })
                .catch(() => {});
            },
            queryUser() {
                this.loading = true;
                this.user.pageNum = this.currentPage;
                this.user.pageSize = this.pageSize;
                this.user.condition.audit = "Y"
                this.$axios.post("/user/findList",this.user).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.users = res.data.result.list;
                            this.total = res.data.result.total;
                        } else {
                            this.$message.error(res.data.message);
                        }
                        this.loading = false;
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            createUser() {
                this.title = "新增用户";
                this.drawer = true;
                this.timer = new Date().getTime();
                this.userProp = {};
            },
            queryUserStatus() {
                let condition = {value:"USER_STATUS"};
                this.$axios.post("/dictionary/findByDictType",condition).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.dataStatuses = res.data.result;
                        }else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            }, 
            closeDrawer() {
                this.drawer = false;
                this.queryUser();
            },
            getTableHeight() {
                let tableH = 300; //距离页面下方的高度
                this.tableHeight = window.innerHeight - tableH;
            },
        },
        mounted() {
            this.queryUser();
            this.queryUserStatus();
            this.$bus.$on(GlobeConstant.userupdate_to_userlist_close, this.closeDrawer);
        },
        beforeDestroy() {
            this.$bus.$off(GlobeConstant.userupdate_to_userlist_close);
        },
        created() {
            this.getTableHeight();
        }
        
    }


</script>

<style scoped>

   .el-form {
       margin-top: 30px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }

   .el-select {
        width: 220px;
    }

    .el-input {
        width: 220px;
    }

</style>
